import React from "react";
import { Mail } from "lucide-react";
import { SUPPORT_EMAIL } from "../../../_assets/branding";
import "./SupportMail.scss";

/**
 * SupportMail component for authentication pages
 * @param {Object} props - Component props
 * @param {string} [props.email] - Support email address (defaults to SUPPORT_EMAIL)
 * @param {string} [props.className=""] - Additional CSS classes
 * @param {boolean} [props.showIcon=true] - Whether to show the mail icon
 * @param {Object} [props.style={}] - Additional inline styles
 * @returns {JSX.Element} SupportMail component
 */
const SupportMail = ({
  email = SUPPORT_EMAIL,
  className = "",
  showIcon = true,
  style = {},
}) => {
  return (
    <div className={`support-mail-container ${className}`} style={style}>
      {showIcon && (
        <span className="mail-icon">
          <Mail size={16} color="#a0a0a0" />
        </span>
      )}
      <a href={`mailto:${email}`} className="mail-text">
        {email}
      </a>
    </div>
  );
};

export default SupportMail;
